import { connect } from 'react-redux';
import { compose } from 'recompose';

import { dispatchChangeApprovalState, dispatchShowGuaranteedTimeModal } from '../actions';

import ApproveButton from './ApproveButton';

const mapStateToProps = (state) => {
  return {
    supervisorId: state.timesheetApprovals.currentSupervisorId,
    disableApproveUnapproveButton: state.timesheetApprovals.disableApproveUnapproveButton,
    disableApproveUnapproveButtonForId: state.timesheetApprovals.disableApproveUnapproveButtonForId,
  };
};

const mapDispatchToProps = {
  dispatchChangeApprovalState,
  dispatchShowGuaranteedTimeModal,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

// ORDER MATTERS.
const enhance = compose(withRedux);

export default enhance(ApproveButton);
